import { render, staticRenderFns } from "./verigirisraporu.vue?vue&type=template&id=20508320"
import script from "./verigirisraporu.vue?vue&type=script&lang=js"
export * from "./verigirisraporu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports